import { BCard, BCardText, BContainer, BModal } from 'bootstrap-vue'
export default {
    components: {
        BCard,
        BCardText,
        BContainer,
        BModal,
    },
    data() {
        return {
            memberId: 0,
            steps: [],
            questions: null,
            currentIndex: -1,
            ended: false,
            displayModal: false,
            loading: true
        }
    },
    created() {
        // console.log('preference data', this.$store.state.auth.user.member_id, this.$route.params.id)
        // if (this.$store.state.auth.user.member_id !== parseInt(this.$route.params.id)) {
        //     this.$router.push('/404')
        // }
        this.memberId = this.$route.params.id
        if (!this.memberId) {
            this.$router.push('/404')
        }
        this.fetchData()
    },
    methods: {
        isMobile() {
            var check = false;
            (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
            return check;
        },
        hideModal() {
            this.displayModal = false
            this.loading = false
        },
        fetchData() {
            this.$http
                .get(`new-preferences?member_id=${this.memberId}`)
                .then((response) => {
                    if (response.status == 200 && response.data.status) {
                        this.questions = response.data.questions
                        this.currentIndex = 0
                        this.steps[this.currentIndex] = this.questions[0]
                        if (response.data.will_show_offer_popup > 0) {
                            this.displayModal = true
                        } else {
                            this.loading = false
                        }
                    }
                })
                .catch((err) => {
                    console.error(err)
                })
        },
        onPrev() {
            this.currentIndex =
                this.currentIndex - 1 <= 0 ? 0 : this.currentIndex - 1
        },
        onNext() {
            let next_question_id = []
            let temp_steps = []
            let present_ques_id = this.steps[this.currentIndex].question_id
            this.steps[this.currentIndex].options.forEach((option) => { 
                if (option.member_ans) {
                    next_question_id.push(option.next_question_id)
                }
            })
            
            next_question_id.forEach((qId) => {
                let next_ques_in_queue = this.questions.find(
                    (item) => item.question_id === qId
                )
                if (next_ques_in_queue) {
                    temp_steps.push(next_ques_in_queue)
                    // temp_steps.sort((item) => item.display_order)
                    temp_steps.sort((item1, item2) => item1.display_order > item2.display_order ? 1 : -1)
                    console.log(temp_steps)
                    if (temp_steps.length > 1) {
                        temp_steps = [
                            ...new Map(
                                temp_steps.map((item) => [
                                    item['question_id'],
                                    item,
                                ])
                            ).values(),
                        ]
                    }
                }
            })

            
            this.steps.length =
                this.steps.findIndex(
                    (item) => item.question_id === present_ques_id
                ) + 1
            this.steps = [...this.steps, ...temp_steps]
            if (this.steps.length > this.currentIndex + 1) {
                this.currentIndex++
            } else {
                this.ended = true
                this.savePref()
            }
        },
        finish() {
            window.close()
        },
        sortObj(obj) {
            return Object.keys(obj)
                .sort()
                .reduce(function (result, key) {
                    result[key] = obj[key]
                    return result
                }, {})
        },
        savePref() {
            let params = []
            this.steps.forEach((step_ques) => {
                let original_ques = this.questions.find(
                    (item) => item.question_id === step_ques.question_id
                )
                if (original_ques) {
                    original_ques.options.forEach((option) => {
                        if (option.member_ans) {
                            params.push({
                                pref_option_id: option.id,
                                member_id: this.memberId,
                                pref_question_id: original_ques.question_id,
                                member_ans: option.member_ans,
                                from_pref_center: 1,
                            })
                        }
                    })
                }
            })
            this.$http
                .post(`save-preferences`, params)
                .then((response) => {
                    if (response.status == 200 && response.data.status) {
                        console.log('success')
                    }
                })
                .catch((err) => {
                    console.error(err)
                })
        },
    },
}
